<div class="main-view no-child-padding">
  <div class="row-no-margin no-child-padding">
    <main>
      <app-demand-page-header-print [demand]="demand"></app-demand-page-header-print> 
      <app-demand-page-content-print [demand]="demand"  (mapIsReady)="updateStream.next($event)"></app-demand-page-content-print> 

      <app-demand-assignment-print *ngIf="showAssignment() && userMode == 'exploitant'" [demand]="demand"></app-demand-assignment-print>
    </main>
  </div>
</div>